import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert, Card } from 'react-bootstrap';
import authService from '../services/authService';
import analyticsService from '../services/analyticsService';

function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await authService.login(
      formData.email,
      formData.password,
      formData.rememberMe
    );

    setLoading(false);

    if (result.success) {
      // Identify user in analytics
      analyticsService.identify(formData.email, {
        email: formData.email
      });
      analyticsService.auth.login('email');

      // Check onboarding path to determine where to redirect
      try {
        const statusResponse = await fetch('/api/quick-start/get-status', {
          method: 'GET',
          credentials: 'include'
        });

        if (statusResponse.ok) {
          const status = await statusResponse.json();

          if (status.onboarding_path === 'quick_start') {
            // Quick-start user
            if (status.quick_start_completed) {
              // Completed - go to quick-start dashboard
              navigate('/quick-start-dashboard');
            } else {
              // Not completed - resume quick-start
              navigate('/quick-start');
            }
            return;
          }
        }
      } catch (err) {
        console.error('Error checking onboarding status:', err);
      }

      // Default: go to main dashboard (guided journey users or fallback)
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundImage: 'url(/images/login-background.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      display: 'flex',
      alignItems: 'center'
    }}>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="shadow" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
              <Card.Body className="p-4">
              <h2 className="text-center mb-4">AI Profit Engineer Login</h2>

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email"
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder="Enter your password"
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="rememberMe">
                  <Form.Check
                    type="checkbox"
                    name="rememberMe"
                    label="Remember me (7 days)"
                    checked={formData.rememberMe}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100 mb-3"
                  disabled={loading}
                  style={{
                    background: 'linear-gradient(135deg, #b78c30 0%, #f7f18f 50%, #b78c30 100%)',
                    border: '2px solid #000',
                    color: '#000',
                    fontWeight: '600',
                    padding: '10px',
                    fontSize: '1.05rem',
                    letterSpacing: '0.5px',
                    boxShadow: '0 2px 8px rgba(212, 160, 23, 0.35)'
                  }}
                >
                  {loading ? 'Logging in...' : 'Login'}
                </Button>

                <div className="text-center">
                  <Link to="/forgot-password" className="d-block mb-2" style={{ color: '#c0392b', textDecoration: 'none' }}>
                    Forgot Password?
                  </Link>
                  <div>
                    Don't have an account? <Link to="/register" style={{ color: '#c0392b', textDecoration: 'none', fontWeight: '600' }}>Register</Link>
                  </div>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
  );
}

export default Login;
